module.exports = __webpack_public_path__ + "img/flag54.3869c547.png";